import React, { useEffect, useState } from "react";
import "./index.css";
import { Button, Form, Stack } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import { useDispatch, useSelector } from "react-redux";
import {
  createLocation,
  fetchsuperadminapproverdata,
} from "../../../redux/slice/CreateLocationSlice";
import { useFormik } from "formik";
import { countryNames } from "../../../services/helper/CountryDataAction";
import axios from "axios";
import { StatusCode } from "../../../services/helper";
import ButtonLoader from "../../../components/Common/ButtonLoader";
import ValidationSchema from "../../../components/Common/ValidationSchema";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { TextField, Autocomplete } from "@mui/material";
import { adminRoles } from "../../../utils/constants";

const CreateLocation = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { ApproversSuperAdminsData, status } = useSelector(
    (state) => state.SUPERADMINAPPROVER
  );
  const { role } = useSelector((state) => state.AUTH);

  const initialValues = {
    location_name: "",
    street: "",
    city: "",
    county: "",
    country: "",
    zip_code: "",
    business_email: "",
    country_code: "+44",
    contact_number: "",
    assigned_admin_id: "",
    assigned_approver_id: "",
    longitude: "",
    latitude: "",
  };

  const [locationSuggestions, setLocationSuggestions] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [locationData, setLocationData] = useState(null);
  const [loading, setLoading] = useState(false);
  const handlePostalCodeChange = async (postalCode) => {
    try {
      const countryCode = "GB"; // Country code for United Kingdom
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?postalcode=${postalCode}&countrycodes=${countryCode}&format=json&addressdetails=1`
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch data. Status: ${response.status}`);
      }

      const data = await response.json();

      if (data && data.length > 0) {
        const city = data[0].address.city || data[0].address.state; // Use state district if city is not available
        const country = data[0].address.country;

        setLocationData(data[0]);

        handleChange({
          target: { name: "city", value: city },
        });
        handleChange({
          target: { name: "country", value: country },
        });
        // handleChange({
        //   target: { name: "street", value: street },
        // });
        handleChange({
          target: { name: "zip_code", value: postalCode },
        });

        // Clear latitude and longitude values when postal code changes
        setFieldValue("latitude", "");
        setFieldValue("longitude", "");
      } else {
        console.error("No location data found in response.");
      }
    } catch (error) {
      console.error("Error fetching location:", error.message);
    }
  };

  // const { values, errors, handleBlur, handleChange, touched, handleSubmit } =
  //   useFormik({
  //     initialValues: initialValues,
  //     validationSchema: ValidationSchema.createLocation,
  //     onSubmit: async (values) => {
  //       const data = await getLatLongData();
  //       if (data === undefined) {
  //         toast.error("Please enter correct location");
  //       } else {
  //         const body = { ...values, longitude: data.lon, latitude: data.lat };
  //         dispatch(createLocation(body));
  //         navigate("/businessprofile");
  //       }
  //     },
  //   });

  const {
    values,
    errors,
    handleBlur,
    handleChange,
    touched,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: ValidationSchema.createLocation,
    onSubmit: async (values) => {
      const data = await getLatLongData(values.street);
      if (!data) {
        toast.error("Please enter a valid location");
        return;
      }

      // Update form values with latitude and longitude
      const updatedValues = {
        ...values,
        longitude: data.lon,
        latitude: data.lat,
      };
      const res = await dispatch(createLocation(updatedValues));
      if (res?.payload?.status === 200) {
        parentUrlRedirection();
      }
    },
  });

  const getLatLongData = async (locationName) => {
    try {
      const response = await axios.get(
        `https://nominatim.openstreetmap.org/search?format=json&q=${locationName}`
      );

      if (response.data.length > 0) {
        return response.data[0];
      } else {
        return null;
      }
    } catch (error) {
      console.error("Error fetching latitude and longitude:", error);
      return null;
    }
  };

  const fetchLocationSuggestions = async (input) => {
    if (input.trim() === "") {
      setLocationSuggestions([]);
      return;
    }
    setLoading(true);
    try {
      const response = await axios.get(
        `https://nominatim.openstreetmap.org/search?format=json&q=${input}`
      );

      setLocationSuggestions(response.data);
    } catch (error) {
      console.error("Error fetching location suggestions:", error);
      setLocationSuggestions([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    dispatch(fetchsuperadminapproverdata());
  }, []);

  const parentUrlRedirection = () => {
    if (adminRoles.includes(role)) {
      navigate("/businessprofile");
    } else {
      navigate("/distributor-business-profile");
    }
  };

  return (
    <div className="bg-white flex-grow-1 d-flex flex-column createlocation popup-layout">
      <div
        className="position-sticky bg-white header-section"
        style={{ zIndex: 1 }}
      >
        <h4 className="text-center m-0 fw-bold">Create A New Location</h4>
        <hr className="my-3 my-md-4" />
      </div>
      <h6 className="text-center mb-4 fw-semibold">
        Enter your business information
      </h6>
      <form
        onSubmit={handleSubmit}
        className="flex-grow-1 d-flex flex-column justify-content-between"
      >
        <div className="row row-gap-3">
          <Form.Group className="col-12" controlId="formBasicLocationName">
            <Form.Control
              type="text"
              name="location_name"
              value={values.location_name}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="Location Name"
              autoComplete="off"
            />
            {errors.location_name && touched.location_name && (
              <p className="text-danger mt-1 mb-0">{errors.location_name}</p>
            )}
          </Form.Group>
          <Form.Group className="col-12" controlId="formBasicStreetAddress">
            <Autocomplete
              freeSolo
              options={locationSuggestions}
              getOptionLabel={(option) => option.display_name || ""}
              isOptionEqualToValue={(option, value) =>
                option?.display_name === value?.display_name
              }
              loading={loading}
              value={selectedLocation}
              onChange={(event, newValue) => {
                setSelectedLocation(newValue);
                setFieldValue("street", newValue?.name || "");
                setFieldValue("display_name", newValue?.display_name || "");
                setFieldValue("latitude", newValue?.lat || "");
                setFieldValue("longitude", newValue?.lon || "");
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  placeholder="Street Address"
                  name="street"
                  onBlur={handleBlur}
                  onChange={(event) => {
                    const { value } = event.target;
                    fetchLocationSuggestions(value);
                  }}
                />
              )}
              renderOption={(props, option) => (
                <li {...props} key={`${option.lat}-${option.lon}`}>
                  {option.display_name}
                </li>
              )}
            />
            {errors.street && touched.street && (
              <p className="text-danger mt-1 mb-0">{errors.street} </p>
            )}
          </Form.Group>
          <Form.Group className="col-12 col-md-6" controlId="formBasicCity">
            <Form.Control
              type="text"
              name="city"
              value={values.city}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="City"
            />
            {errors.city && touched.city && (
              <p className="text-danger mt-1 mb-0">{errors.city} </p>
            )}
          </Form.Group>
          <Form.Group className="col-12 col-md-6" controlId="formBasicCounty">
            <Form.Control
              type="text"
              name="county"
              value={values.county}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="County"
            />
            {errors.county && touched.county && (
              <p className="text-danger mt-1 mb-0">{errors.county} </p>
            )}
          </Form.Group>
          <Form.Group className="col-12 col-md-6" controlId="formBasicCountry">
            <Form.Select
              aria-label="Default select example"
              name="country"
              onChange={handleChange}
              value={values.country}
              onBlur={handleBlur}
            >
              <option value="" disabled className="option-title">
                Country
              </option>
              {countryNames &&
                countryNames.map((curElm, index) => (
                  <option value={curElm.label} key={index}>
                    {curElm.label}
                  </option>
                ))}
            </Form.Select>
            {errors.country && touched.country && (
              <p className="text-danger mt-1 mb-0">{errors.country} </p>
            )}
          </Form.Group>
          <Form.Group className="col-12 col-md-6" controlId="formBasicZipCode">
            <Form.Control
              type="text"
              name="zip_code"
              onChange={(e) => handlePostalCodeChange(e.target.value)}
              placeholder="Postal Code"
            />
            {/* Display location data if available */}
            {locationData && (
              <div>
                <p> {locationData.city}</p>
                <p> {locationData.state_district}</p>
                <p>{locationData.country}</p>
              </div>
            )}
            {errors.zip_code && touched.zip_code && (
              <p className="text-danger mt-1 mb-0">{errors.zip_code} </p>
            )}
          </Form.Group>
          <div className="col-12">
            <hr />
          </div>
          <Form.Group className="col-12" controlId="formBasicBusinessEmail">
            <Form.Control
              type="email"
              name="business_email"
              value={values.business_email}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="Business Email"
            />
            {errors.business_email && touched.business_email && (
              <p className="text-danger mt-1 mb-0">{errors.business_email} </p>
            )}
          </Form.Group>
          <Form.Group className="col-12" controlId="formBasicCountryCode">
            <div className="phn_input">
              <div className="phoneInput">
                {/* <PhoneInput
                    name="country_code"
                    className="w-100"
                    country={"gb"}
                    value={values.country_code}
                    onChange={(value) =>
                      handleChange({
                        target: { name: "country_code", value },
                      })
                    }
                  />{" "} */}
                <PhoneInput
                  name="country_code"
                  // className="w-100"
                  disableTyping={true}
                  inputProps={{
                    readOnly: true,
                  }}
                  country={"gb"}
                  value={values.country_code}
                  onChange={(value) =>
                    handleChange({
                      target: { name: "country_code", value: "+" + value }, // Add "+" here
                    })
                  }
                />
              </div>
              <Form.Control
                onKeyPress={(e) => {
                  if (e.key === "e" || e.key === "E" || isNaN(Number(e.key))) {
                    e.preventDefault();
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === " ") {
                    e.preventDefault();
                  }
                }}
                type="text"
                pattern="[0-9]*"
                name="contact_number"
                value={values.contact_number}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Number"
              />
            </div>
            <Stack direction="horizontal" gap={2}>
              {errors.country_code && touched.country_code && (
                <p className="text-danger mt-1 mb-0">{errors.country_code}</p>
              )}
              {errors.contact_number && touched.contact_number && (
                <p className="text-danger mt-1 mb-0">{errors.contact_number}</p>
              )}
            </Stack>
          </Form.Group>
          <Form.Group className="col-12" controlId="formBasicAssignSuperAdmin">
            <Form.Select
              aria-label="Default select example"
              className="text-capitalize"
              name="assigned_admin_id"
              onChange={handleChange}
              value={values.assigned_admin_id}
              onBlur={handleBlur}
            >
              <option value="" disabled className="option-title">
                Assigned Super Admin
              </option>
              {ApproversSuperAdminsData &&
                ApproversSuperAdminsData.Superadmins?.map((curElm) => (
                  <option value={curElm._id} key={curElm._id}>
                    {curElm.first_name} {curElm.last_name}
                  </option>
                ))}
            </Form.Select>
            {/* {errors.assigned_admin_id && touched.assigned_admin_id && (
                  <p className="text-danger mt-1 mb-0">{errors.assigned_admin_id} </p>
                )} */}
          </Form.Group>
          <Form.Group
            className="col-12 mb-3"
            controlId="formBasicAssignApprover"
          >
            <Form.Select
              aria-label="Default select example"
              name="assigned_approver_id"
              onChange={handleChange}
              value={values.assigned_approver_id}
              onBlur={handleBlur}
            >
              <option value="" disabled className="option-title">
                Assigned Approver
              </option>
              {ApproversSuperAdminsData &&
                ApproversSuperAdminsData.Approvers?.map((curElm) => (
                  <option value={curElm._id} key={curElm._id}>
                    {curElm.first_name} {curElm.last_name}{" "}
                  </option>
                ))}
            </Form.Select>
            {/* {errors.assigned_approver_id && touched.assigned_approver_id && (
                  <p className="text-danger mt-1 mb-0">{errors.assigned_approver_id} </p>
                )} */}
          </Form.Group>
        </div>
        <div className="position-sticky bg-white footer-section">
          <hr className="mt-0" />
          <div className="d-flex align-items-end justify-content-end flex-wrap-reverse gap-3">
            <Button
              className="btn btn-dark flex-grow-1 flex-sm-grow-0"
              onClick={parentUrlRedirection}
            >
              Cancel
            </Button>
            <button
              className="btn btn-primary p-auto px-xxl-5 flex-grow-1 flex-sm-grow-0"
              type="submit"
            >
              {status === StatusCode.LOADING ? (
                <ButtonLoader />
              ) : (
                "Save Location"
              )}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default CreateLocation;
